<template>
  <transition name="bounce">
    <div v-if="cpntRefsId !== ''" class="rf-web-tooltip" v-show="mostrar" @click='tooltipMostraOculta($event, "", true)'>
      <div :id="cpntRefsId + '-conteudo'" class="rf-web-tooltip-div" :style="'width: ' + cpntTamanho + ';'" :data-time="time" v-show="mostrar" 
        @mouseover='tooltipMostraOculta'
        @mouseleave='tooltipMostraOculta'
        @click.stop>
        <div v-if="Object.keys($slots).indexOf('titulo') !== -1" class="rf-web-tooltip-titulo">
          <i aria-hidden="true" class="fa fa-angle-double-right"></i>
          <slot name="titulo"></slot>
        </div>

        <div v-if="Object.keys($slots).indexOf('conteudo') !== -1" class="rf-web-tooltip-conteudo">
          <slot name="conteudo"></slot>
        </div>
      </div>

      <template v-if="cpntMenu === true">
        <div class="web-barra-sob-menu-1" @mouseover='tooltipMostraOculta' @mouseleave='tooltipMostraOculta'></div>
        <div class="web-barra-sob-menu-2" @mouseover='tooltipMostraOculta' @mouseleave='tooltipMostraOculta'></div>
      </template>
    </div>
  </transition>
</template>
 
<style scoped>
  .rf-web-tooltip {
    position: fixed;
    top: 70px;
    left: 0px;
    /* background-color: #ccc; */

    width: 100%;
    height: 100%;
    z-index: 4990;
  }
    .web-barra-sob-menu-1, .web-barra-sob-menu-2 {
      position: fixed;
      top: 0px;
      height: 68px;
      /* background: #ccc !important; */
      z-index: 4980 !important;
    }
    .web-barra-sob-menu-1 {
      left: 0px;
    }
    .web-barra-sob-menu-2 {
      right: 0px;
    }
    .rf-web-tooltip > .rf-web-tooltip-div {
      z-index: 5000;
      position: fixed;

      background-color: #fff;
      -webkit-box-shadow: 5px 5px 11px 0px rgba(207,207,207,1);
      -moz-box-shadow: 5px 5px 11px 0px rgba(207,207,207,1);
      box-shadow: 5px 5px 11px 0px rgba(207,207,207,1);
      border: 1px solid #ccc;
      border-radius: 5px;
      
      max-width: 580px;

      color: var(--color-base-01);
      font-size: var(--font-base-soma-14);
      line-height: 16px;
    }
      .rf-web-tooltip > .rf-web-tooltip-div > .rf-web-tooltip-titulo {
        background: #e9e9e9;
        padding: 10px 20px 10px 20px;
        color: var(--color-base-02);
        text-align: left;
        border-bottom: 1px solid #ccc;
      }
      .rf-web-tooltip > .rf-web-tooltip-div > .rf-web-tooltip-conteudo {
        padding: 8px 20px 8px 20px;
        overflow: auto;
        max-height: 80vh;
      }
</style>

<script>
export default {
  props: {
    cpntTamanho: {
      required: false,
      type: String,
      default: function () {
        return '500px'
      }
    },
    cpntTitle: {
      required: false,
      type: String,
      default: function () {
        return 'Rotina Fácil'
      }
    },
    cpntRefsId: {
      required: true,
      type: String
    },
    cpntDisabled: {
      required: false,
      type: Boolean,
      default: function () {
        return false
      }
    },
    cpntPosicao: {
      required: false,
      type: Boolean,
      default: function () {
        return true
      }
    },
    cpntMenu: {
      required: false,
      type: Boolean,
      default: function () {
        return false
      }
    },
    cpntTipoEvento: {
      required: true,
      type: Array
    },
    cpntTooltipAtualiza: {
      required: false,
      default: function () {
        return null
      }
    }
  },
  data: function () {
    return {
      time: '',
      referencia: null,
      requestId: '',
      requestTipo: '',
      mostrar: false
    }
  },
  mounted: function () {
    this.tooltipIniciar()
  },
  methods: {
    tooltipIniciar: function () {
      var self = this

      if (this.$parent.$refs.hasOwnProperty(self.cpntRefsId)) {
        self.referencia = this.$parent.$refs[self.cpntRefsId]
      }

      if (Array.isArray(self.referencia)) {
        self.referencia = self.referencia[0]
      }

      if ([ '', null, undefined ].indexOf(self.referencia) === -1 && [ '', null, undefined ].indexOf(self.referencia.id) === -1) {
        // REGISTRA OS EVENTOS DE MOUSE NA REFERENCIA
        if (self.cpntTipoEvento.indexOf('mouse') !== -1) {
          // SETA A FUNÇÃO QUANDO COLOCA O MOUSE SOBRE A REFERENCIA
          self.referencia.addEventListener('mouseover', self.tooltipMostraOculta)

          // SETA A FUNÇÃO QUANDO TIRA O MOUSE SOBRE A REFERENCIA
          self.referencia.addEventListener('mouseleave', self.tooltipMostraOculta)
        }

        // REGISTRA OS EVENTOS DE CLICK NA REFERENCIA
        if (self.cpntTipoEvento.indexOf('click') !== -1) {
          self.referencia.addEventListener('click', self.tooltipMostraOculta)
        }

        // SETA O FLAG INICIAL
        self.mostrar = false

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()
      } else {
        // eslint-disable-next-line
        console.error('WEB [500]: Erro ao carregar tooltip (' + self.cpntRefsId + ').')
      }
    },
    tooltipMostraOculta: function ($event, requestId = '', close = false) {
      if (this.cpntDisabled === false) {
        if (requestId === '' || (requestId !== this.requestId)) {
          // SETA O REQUEST DA REQUISIÇÃO
          this.requestId = (Math.floor(Math.random() * (9999 - 1000)) + 1000)

          if (requestId === '') {
            requestId = this.requestId
          }

          if ($event.type === 'click') {
            // SETA O FLAG DEVE OU NÃO MOSTRAR
            if (this.requestTipo === 'click' && this.mostrar === false) {
              this.mostrar = true
            } else if (this.requestTipo !== 'click' && this.mostrar === false && close === false) {
              this.mostrar = true
            } else if (this.requestTipo !== 'click' && this.mostrar === true && close === false) {
              this.mostrar = true
            } else if (this.requestTipo !== 'click' && this.mostrar === true && close === true) {
              this.mostrar = false
            } else if (this.requestTipo === 'click' && this.mostrar === true) {
              this.mostrar = false
            }

            // SETA O TIPO DE AÇÃO QUE INICIOU O PROCESSO
            if (this.mostrar === false) {
              this.requestTipo = ''

              if (close === true && typeof $event.clientX === 'number' && typeof $event.clientY === 'number') {
                setTimeout(function () {
                  document.elementFromPoint($event.clientX, $event.clientY).click()
                }, 100)
              }
            } else {
              this.requestTipo = $event.type
            }
          } else if (this.requestTipo !== 'click' && $event.type !== 'click') {
            var self = this

            setTimeout(function () {
              if (requestId === self.requestId) {
                self.tooltipMostraOculta($event, self.requestId, close)
              }
            }, $event.type === 'mouseleave' ? 250 : 50)
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        } else if (requestId === this.requestId && this.requestTipo !== 'click' && $event.type !== 'click') {
          // SETA O FLAG DEVE OU NÃO MOSTRAR
          this.mostrar = $event.type === 'mouseover'

          // SETA O TIPO DE AÇÃO QUE INICIOU O PROCESSO
          this.requestTipo = $event.type

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      }
    },
    tooltipForcarFechamento: function () {
      // SETA O FLAG DEVE OU NÃO MOSTRAR
      this.mostrar = false

      // SETA O TIPO DE AÇÃO QUE INICIOU O PROCESSO
      this.requestTipo = ''

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    tooltipCalcularPosicao: function () {
      if (this.cpntPosicao === true) {
        var referencia = $('#' + this.cpntRefsId)
        var tooltip = $('#' + this.cpntRefsId + '-conteudo')
        var tela = $(document)

        // INICIA A VARIAVEL DE POSSIÇÃO DO TOOLTIP
        var posicao = {}

        // SETA A ALTURA QUE DEVE FICAR O TOOLTIP
        posicao.top = (referencia.height() + 34)

        if ((tela.width() - (tooltip.width() + referencia.offset().left)) >= 0) {
          posicao.left = referencia.offset().left
        } else {
          posicao.left = (tela.width() - tooltip.width()) - 15
        }

        // SETA OS DADOS CONFIGURADOS
        tooltip.css(posicao)

        if (this.cpntMenu === true) {
          $('#' + this.cpntRefsId + '-conteudo ~ .web-barra-sob-menu-1').width((referencia.offset().left - referencia.width()) <= 0 ? (referencia.offset().left - 5) : ((referencia.offset().left - referencia.width()) + 10))

          $('#' + this.cpntRefsId + '-conteudo ~ .web-barra-sob-menu-2').width((tela.width() - (referencia.offset().left + referencia.width()) - 25))
        }
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  },
  watch: {
    mostrar: function () {
      // INICIA O CALCULO DA POSIÇÃO DO TOOLTIP
      if (this.mostrar === true) {
        this.tooltipCalcularPosicao()
      }

      // CHAMA A FUNÇÃO QUE ESTA ABRINDO O TOOLTIP
      if (this.cpntTooltipAtualiza !== null) {
        this.cpntTooltipAtualiza(this.cpntRefsId, this.mostrar)
      }
    }
  }
}
</script>

